import { TitleCasePipe } from "@angular/common";
import { Component, input, InputSignal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { FirstReportDataResponse, OutgoingTransaction, ReportProcess } from "../../../../api/api.model";
import { InfoComponent } from "../../info/info.component";
import { ReportStatusComponent } from "../../report-status/report-status.component";

@Component({
  selector: 'app-report-triggers',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    InfoComponent,
    ReportStatusComponent,
    TitleCasePipe,
  ],
  templateUrl: './report-triggers.component.html',
  styleUrl: './report-triggers.component.scss'
})
export class ReportTriggersComponent {
  riskResponse: InputSignal<FirstReportDataResponse | OutgoingTransaction> = input.required();
  typeReport: InputSignal<ReportProcess> = input.required();

  public get typeReportKey(): string {
    switch (this.typeReport()) {
      case 'FIRST_REPORT':
        return 'first_report';
      case 'TOP_10':
        return 'top_10';
      case 'SUSPISIOUS_WALLET':
        return 'problem_wallets';
      default: {
        throw new Error("Not found type report");
      }
    }
  }
}
